import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom'
import { Col, Container, Row } from "reactstrap";
import { Card, CardBody } from "reactstrap";
import Table from "react-bootstrap/Table";
import { ExternalLink } from "react-feather";
import ProfileDetails from "components/LM/SocialMediaProfile/ProfileDetails";
import ErrorDetails from 'components/LM/SocialMediaProfile/ErrorDetails';
import Loader from "components/Loader";
import K2Api from 'lib/ajax/K2Api';
import 'components/LM/SocialMediaProfile/SocialMediaProfile.scss';

function ExploreProfile(props) {

  const { type, typeName } = props;
  const [profile, setProfile] = useState();
  const [posts, setPosts] = useState();
  const [error, setError] = useState();
  const { identifier } = useParams();

  useEffect(() => {
    async function fetchData() {

      try {
        const profileFromUrl = await retrieveProfile(identifier);
        if (!profileFromUrl) return;

        setProfile({ ...profileFromUrl, info: profileFromUrl });
        if (profileFromUrl.is_business) {
          const posts = await retrievePosts('instagram', identifier);
          setPosts(posts)
        }
      } catch (err) {
        console.error(err);
        setError(err);
      }
    }
    fetchData();
  }, [identifier]);

  if (error) {
    return <ErrorDetails error={error} />;
  } else if (profile) {
    return (
      <div id={type + typeName}>
        <Container fluid className="p-0">
          <h1 className="h3 mb-3">Instagram profile: {profile.info.screen_name} <a href={profile.info.profile_url} target='_blank' className='external-link' rel='noopener noreferrer'><ExternalLink className="feather align-middle mr-2" /></a></h1>
          <Row>
            <Col md="4" xl="3">
              <ProfileDetails type='instagram' typeName='profile' profile={profile} audienceLabel='followers' showRecoveryButton={false} showExtendedInfo={false} usePictureUrl={!profile.info?.voice?.id} />
            </Col>
            <Col md="8" xl="9">
              <Card>
                <CardBody>
                  {profile.info.is_business ? <PostsTable posts={posts} /> : <div> This Profile is NOT business so the explore feature is not available</div>}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  } else {
    return <Loader />;
  }
}


async function retrieveProfile(identifier) {

  const k2Api = new K2Api();

  const url = `https://www.instagram.com/${identifier}`
  const profile = await k2Api.get('/socialmedia/search', { params: { url } });

  if (!profile) return;

  // BIT-2338 (BIT-2280) Duplicated instagram profile by screen_name.
  // We can receive more than one profile. The first item is the most updated
  const profileInfo = profile.data.result[0];

  let canRecover;
  try {
    const response = await k2Api.get(`/socialmedia/instagram/recovery/${profileInfo.id}`);
    canRecover = response.data;
  } catch (err) {
    if (err.response.status === 404) {
      canRecover = {
        can_recover: false,
        reason: err.response.data.errors[0]
      };
    } else {
      throw err;
    }
  }

  profileInfo.recovery = canRecover;

  return profileInfo;
}


async function retrievePosts(type, id) {

  const k2Api = new K2Api();

  const posts = await k2Api.get(`/socialmedia/${type}/posts/${id}`).catch(
    err => {
      // This will allow the page to work without the posts endpoint
      return []
    }
  );

  return posts.data
}

function PostsTable(props) {
  const { posts } = props;

  let rows;
  if (posts) {
    rows = posts.map(row => {
      return (<tr key={row.id}>
        <td>{row.date}</td>
        <td><a href={row.url} target="_blank" rel="noopener noreferrer">{row.text || (<i>No caption</i>)}</a></td>
        <td><PostMedia mediaType={row.media_type} mediaUrl={row.media_url} /></td>
      </tr>)
    });
  }

  if (rows) {
    return (
      <Table striped>
        <thead>
          <tr>
            <th>Date</th>
            <th>Caption</th>
            <th>Image</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>
    );
  } else {
    return <Loader />
  }
}

function PostMedia(props) {
  const { mediaType, mediaUrl } = props;

  if (!mediaType || !mediaUrl) return "No content available";

  if (mediaType === 'video') {
    return <video controls src={mediaUrl} referrerPolicy="no-referrer" alt="" height="200" />
  } else {
    return <img src={mediaUrl} referrerPolicy="no-referrer" alt="" height="200" />
  }
}

export default ExploreProfile;
